import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AgentState {
  id: string;
  workPlaceId?: string;
  companyId?: string;
  workPlace?: any;
  company?: any;
  name: string;
  phone: string;
  email: string;
  role: string;
  isActive: boolean;
  isDefaultOnInterventionFile: boolean;
  receivesInterventionFileEmails: boolean;
  props: {
    [key: string]: any;
  };
}

const initialState: AgentState = {
  id: '',
  workPlaceId: '',
  workPlace: null,
  companyId: '',
  company: null,
  name: '',
  phone: '',
  email: '',
  role: '',
  isActive: false,
  isDefaultOnInterventionFile: false,
  receivesInterventionFileEmails: false,
  props: { isModalVisible: false, refresh: false, searchTerm: '', skip: 1, take: 10, totalItems: 0 },
};

const agentSlice = createSlice({
  name: 'agent',
  initialState,
  reducers: {
    setAgent: (state, action: PayloadAction<Partial<AgentState>>) => {
      return { ...state, ...action.payload };
    },

    resetProps: (_state, action: PayloadAction<Partial<AgentState['props']> | undefined>) => {
      return {
        ...initialState,
        props: { ...initialState.props, ...action.payload },
      };
    },

    updateField: (state: AgentState, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      (state as any)[field] = value;
    },

    updateProps: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props = {
        ...state.props,
        [field]: value,
      };
    },
  },
});

export const { setAgent, resetProps, updateField, updateProps } = agentSlice.actions;

export default agentSlice.reducer;
